export default class APIEntry {
  constructor(path, method) {
    this.path = path;
    this.method = method;
  }

  getPath() {
    return this.path;
  }

  getMethod() {
    return this.method;
  }
}
